const form = {
  formId: "new-milestone-form",
  formField: {
    // name: {
    //   name: "name",
    //   label: "اسم المرحلة",
    //   type: "text",
    //   errorMsg: "اسم المرحلة مطلوب.",
    // },
    description: {
      name: "description",
      label: "الوصف",
      type: "text",
      errorMsg: "الوصف مطلوب.",
    },
    ResponsibilityText: {
      name: "responsibilityText",
      label: "المسؤولية",
      type: "text",
      errorMsg: "المسؤولية مطلوبة.",
    },
    SolutionDescription: {
      name: "solutionDescription",
      label: "الحل",
      type: "text",
      errorMsg: "الحل مطلوب.",
    },

    startDate: {
      name: "startDate",
      label: "تاريخ البدء",
      type: "date",
      errorMsg: "تاريخ البدء مطلوب.",
    },
    endDate: {
      name: "endDate",
      label: "تاريخ الانتهاء",
      type: "date",
      errorMsg: "تاريخ الانتهاء مطلوب.",
    },
    priority: {
      name: "priorityId",
      label: "المؤشر",
      type: "number",
      errorMsg: " المؤشر مطلوب.",
    },
    Status: {
      name: "statusId",
      label: "الحالة",
      type: "number",
      errorMsg: "الحالة مطلوبة.",
    },
    projectId: {
      name: "projectId",
      label: "رقم المشروع",
      type: "text",
      errorMsg: "رقم المشروع مطلوب.",
    },
  },
};

export default form;
